import { render, staticRenderFns } from "./AddContractorToManagerNew.vue?vue&type=template&id=2aff3eab"
import script from "./AddContractorToManagerNew.vue?vue&type=script&lang=ts"
export * from "./AddContractorToManagerNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aff3eab')) {
      api.createRecord('2aff3eab', component.options)
    } else {
      api.reload('2aff3eab', component.options)
    }
    module.hot.accept("./AddContractorToManagerNew.vue?vue&type=template&id=2aff3eab", function () {
      api.rerender('2aff3eab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/AddContractorToManagerNew.vue"
export default component.exports